import React from "react";
import { useFieldArray } from "react-hook-form";
import "../constants/constants.css";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";

const InfoFields = ({ control, register, index, indexDetails }) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: `creatives[${index}].details[${indexDetails}].infoFields`,
  });

  return (
    <div className="form-wrapper">
      <ul>
        <p className="message">
          Here you should add the generic information like the Video Files and
          Creative Assets
        </p>
        {fields.map((item, indexInfoFields) => {
          return (
            <li key={item.id} className="form-wrapper-info-fields">
              <h4>Information Fields</h4>
              <div className="input-container">
                <div className="inner-input-container">
                  <InputFieldFormArray
                    label="Subject"
                    placeholder="Encoding / Position in previewer / etc."
                    fieldRef={register(
                      `creatives[${index}].details[${indexDetails}].infoFields[${indexInfoFields}].subject`,
                      {
                        required: false,
                      }
                    )}
                    name={`creatives[${index}].details[${indexDetails}].infoFields[${indexInfoFields}].subject`}
                    key={item.id}
                  />

                  <InputFieldFormArray
                    label="Text"
                    placeholder="MP4 / Assets"
                    fieldRef={register(
                      `creatives[${index}].details[${indexDetails}].infoFields[${indexInfoFields}].text`,
                      {
                        required: false,
                      }
                    )}
                    name={`creatives[${index}].details[${indexDetails}].infoFields[${indexInfoFields}].text`}
                    key={item.id + 1}
                  />

                  <section className="select-wrapper">
                    <div className="label-wrapper">
                      <label>Type </label>
                    </div>
                    <div>
                      <select
                        {...register(
                          `creatives[${index}].details[${indexDetails}].infoFields[${indexInfoFields}].type`,
                          { required: false }
                        )}
                      >
                        <option value="text">text</option>
                        <option value="url">url</option>
                      </select>
                    </div>
                  </section>

                  <InputFieldFormArray
                    label="Url "
                    fieldRef={register(
                      `creatives[${index}].details[${indexDetails}].infoFields[${indexInfoFields}].url`,
                      {
                        required: false,
                      }
                    )}
                    name={`creatives[${index}].details[${indexDetails}].infoFields[${indexInfoFields}].url`}
                    key={item.id + 2}
                  />

                  <button
                    className="info-fields-button delete-button"
                    type="button"
                    onClick={() => {
                      remove(indexInfoFields);
                    }}
                  >
                    Delete <br /> Information Fields
                  </button>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      <button
        className="append-button"
        type="button"
        onClick={() => {
          append({ subject: "", text: "", type: "text", url: "" });
        }}
      >
        Add <br /> Information Fields
      </button>
    </div>
  );
};

export default InfoFields;
